module.exports = __webpack_public_path__ + "img/haijunlan2.8e032d8b.png";